<template>
    <div class="mb-3">
        <h3 class="mb-3">Teams</h3>
        <el-form ref="form" :model="form" label-position="top">
            <el-row :gutter="24">
                <el-col :span="12">
                    <div v-for="team in teams" :key="team.id">
                        <el-switch
                            class="mb-2"
                            style="display: block"
                            v-model="form.teams[team.id]"
                            :active-value="true"
                            :inactive-value="false"
                            :active-text="team.name"
                        ></el-switch>
                        <el-form-item v-if="form.teams[team.id]" :label="`Team ${team.name} Email`">
                            <el-input style="width: 350px;" type="email" v-model="form.emails[team.id]"
                                      :placeholder="user.email"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Current Team" prop="current_team_id">
                        <el-select
                            clearable
                            v-model="form.user.current_team_id"
                            placeholder="Current Team"
                            class="w-100"
                        >
                            <el-option v-for="team in teams" :key="team.id" :label="team.name"
                                       :value="team.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "UserTeamSelector",
    props: {
        teams: {
            required: true,
        },
        user: {
            required: true
        },
    },
    data() {
        return {
            saveDelay: 1000,
            saveTimeout: null,
            abortController: null,
            form: {
                teams: {},
                emails: {},
                user: this.user
            },
        }
    },

    mounted() {
        this.user.teams.forEach(team => {
            if (team.teamable) {
                Vue.set(this.form.teams, team.teamable.team_id, true)
                Vue.set(this.form.emails, team.teamable.team_id, team.teamable.email)
            }
        })
    },

    watch: {
        form: {
            handler() {
                this.cancelToken()
                if (this.saveTimeout) clearTimeout(this.saveTimeout)
                this.saveTimeout = setTimeout(() => {
                    this.triggerSave()
                }, this.saveDelay)
            },
            deep: true
        }
    },

    methods: {
        cancelToken() {
            if (this.abortController) {
                this.abortController.abort()
            }
        },
        triggerSave() {
            this.cancelToken()
            this.abortController = new AbortController();
            this.save()
        },
        save() {
            axios
                .post(`/admin/auth/user/${this.user.id}/save-user-team`, this.form, {
                    signal: this.abortController.signal,
                })
                .catch((err) => {
                    if (!axios.isCancel(err)) {
                        console.error(err)
                    }
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.el-form {
    .el-form-item__label {
        line-height: 40px;
        margin: 0;
        padding: 0;
    }
}
</style>
